import { useContext } from 'react';

import { Box, Button, Typography, useTheme } from '@mui/material';

import { REDUCERS } from '@/constants/reducers';
import { currentSeason } from '@/constants/site';
import { Context } from '@/context';
import { getMasterPhotoById } from '@/helpers/images-helper';

import CustomImageComponent from '../custom/custom-image';
import CalendarioFantasyAdminIcon from '../icons/calendario-fantasy-admin';
import CloseIcon from '../icons/close-icon';
import HistoricIcon from '../icons/historic-icon';
import MinutesIcon from '../icons/minutes';
import ProfileIcon from '../icons/profile-icon';
import ProjectionIcon from '../icons/projection-icon';
import FavoriteToggleButton from '../favoritos/FavoriteToggleButton';
import PlacementModalComponent from '@/components/ads-components/placements/placementModal';

const ActionsPlayerContent = ({
    playerId,
    style,
    setOpen,
    shouldDisplayCloseIcon = true,
    showHeader = true,
}) => {
    const { dispatch } = useContext(Context);
    const theme = useTheme();

    const handleClosedModal = () => {
        if (setOpen) {
            setOpen(false);
        }

        dispatch({
            type: REDUCERS.SHOW_MASTER_ACCIONES_PLAYER_ID,
            payload: null,
        });
    };

    const handleClickOnPlayerProfile = () => {
        handleClosedModal();
        dispatch({
            type: REDUCERS.SHOW_PLAYER_PROFILE,
            payload: { playerId, selectedIndex: 2 },
        });
    };

    const handleClickOnPlayerHistoric = () => {
        handleClosedModal();
        dispatch({
            type: REDUCERS.SHOW_FANTASY_HISTORIC,
            payload: { playerId, season: currentSeason },
        });
    };

    const handleClickOnPlayerProjection = () => {
        handleClosedModal();
        dispatch({
            type: REDUCERS.SHOW_MARKET_PROJECTION,
            payload: playerId,
        });
    };

    const handleClickOnPlayerCalendar = () => {
        handleClosedModal();
        dispatch({
            type: REDUCERS.SHOW_PLAYER_CALENDAR,
            payload: playerId,
        });
    };

    const handleClickOnPlayerMinutes = () => {
        handleClosedModal();
        dispatch({
            type: REDUCERS.SHOW_PLAYER_MINUTES,
            payload: playerId,
        });
    };

    const itemStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: theme.palette.background.default,
        borderRadius: '8px',
        padding: showHeader ? '8px 12px' : '0px',
    };

    return (
        <Box
            sx={{
                border: showHeader ? `1px solid ${theme.palette.border.main}` : 'none',
                backgroundColor: theme.palette.background.default,
                maxWidth: showHeader ? '400px' : '100%',
                ...style,
            }}
        >
            {/* Encabezado */}
            {showHeader && (
                <Box sx={{ ...itemStyle, borderBottom: `1px solid ${theme.palette.border.main}` }}>
                    <Box display={'flex'} alignItems={'center'} gap={'4px'}>
                        {playerId > 0 && (
                            <CustomImageComponent
                                src={getMasterPhotoById(playerId, 75)}
                                width={50}
                                height={50}
                            />
                        )}
                        <Typography>Acciones sobre el jugador</Typography>
                        <FavoriteToggleButton playerId={playerId} size={20} sx={{ ml: 1 }} />
                    </Box>
                    {shouldDisplayCloseIcon && (
                        <CloseIcon onClick={handleClosedModal} style={{ cursor: 'pointer' }} />
                    )}
                </Box>
            )}

            {/* Cuerpo */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                }}
            >
                {/* Acción 1 */}
                <Box sx={itemStyle} onClick={handleClickOnPlayerProfile}>
                    <Button variant="outlined" color="primary" fullWidth>
                        <ProfileIcon />
                        <Typography ml={1}>Perfil del jugador</Typography>
                    </Button>
                </Box>

                <Box sx={itemStyle} onClick={handleClickOnPlayerHistoric}>
                    <Button variant="outlined" color="primary" fullWidth>
                        <HistoricIcon />
                        <Typography ml={1}>Histórico de mercado</Typography>
                    </Button>
                </Box>

                <PlacementModalComponent playerId={playerId} />

                {/* Acción 3 */}
                <Box sx={itemStyle} onClick={handleClickOnPlayerProjection}>
                    <Button variant="outlined" color="primary" fullWidth>
                        <ProjectionIcon />
                        <Typography ml={1}>Proyección de mercado</Typography>
                    </Button>
                </Box>

                {/* Acción 4 */}
                <Box sx={itemStyle} onClick={handleClickOnPlayerCalendar}>
                    <Button variant="outlined" color="primary" fullWidth>
                        <CalendarioFantasyAdminIcon iconWidth={'20px'} iconHeight={'20px'} />
                        <Typography ml={1}>Calendario próximos partidos</Typography>
                    </Button>
                </Box>

                {/* Acción 5 */}
                <Box sx={itemStyle} onClick={handleClickOnPlayerMinutes}>
                    <Button variant="outlined" color="primary" fullWidth>
                        <MinutesIcon iconWidth={'20px'} iconHeight={'20px'} />
                        <Typography ml={1}>Minutos disputados</Typography>
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export default ActionsPlayerContent;
